import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated as isAuthenticatedSelector } from "app/pages/Auth/authSelectors";

import { useSelector } from "react-redux";

const PrivateRoute = ({ children, authPath }) => {
	const isAuthenticated = useSelector(state => isAuthenticatedSelector(state));
	const location = useLocation();
	return isAuthenticated ? (
		<>{children}</>
	) : (
		<Navigate
			replace
			to={{
				pathname: authPath,
				search: `?onauthsuccess=${location.pathname}`,
			}}
		/>
	);
};

export default PrivateRoute;

PrivateRoute.propTypes = {
	authPath: PropTypes.string,
};
